import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

const DimCard = ({ label, value, unit = 'cm' }) => (
    <div className="bg-base-200 rounded-lg px-2 py-1.5 text-center">
        <p className="text-[10px] text-base-content/50">{label}</p>
        <p className="text-xs font-semibold text-base-content">
            {value != null ? <>{value}<span className="text-[10px] font-normal ml-0.5">{unit}</span></> : '—'}
        </p>
    </div>
);

// Panel de información del modelo (nombre, dimensiones, nº de piezas),
// compartido por los visores 3D. `formData` es el `form2d_data` del modelo
// (o el subconjunto que devuelve el endpoint de metadatos público).
const InfoPanel = ({ modelName, formData, meshCount, onClose }) => {
    const baseLayout = formData?.baseLayout || {};
    const thickness = formData?.thiknessModelo3d;
    const widthCm = baseLayout.width != null ? (baseLayout.width / 10).toFixed(1) : null;
    const heightCm = baseLayout.height != null ? (baseLayout.height / 10).toFixed(1) : null;
    const thicknessCm = thickness != null ? (thickness / 10).toFixed(1) : null;

    return (
        <div className="absolute bottom-20 left-4 right-4 lg:left-auto lg:right-4 lg:w-72 z-40">
            <div className="bg-base-100/95 backdrop-blur-lg border border-base-300 rounded-2xl shadow-2xl p-4">
                <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                        <InformationCircleIcon className="w-4 h-4 text-primary" />
                        <p className="text-xs font-semibold text-base-content/70 uppercase tracking-wide">
                            Información del modelo
                        </p>
                    </div>
                    <button
                        onClick={onClose}
                        className="btn btn-xs btn-ghost btn-circle"
                        aria-label="Cerrar"
                    >
                        ✕
                    </button>
                </div>

                <div className="space-y-3">
                    {/* Nombre */}
                    <div className="flex items-center justify-between py-2 border-b border-base-300/60">
                        <span className="text-xs text-base-content/50">Nombre</span>
                        <span className="text-xs font-semibold text-base-content truncate max-w-[60%] text-right">
                            {modelName}
                        </span>
                    </div>

                    {/* Dimensiones en cm */}
                    <div className="py-2 border-b border-base-300/60">
                        <span className="text-xs text-base-content/50 block mb-1.5">Dimensiones</span>
                        <div className="grid grid-cols-3 gap-1.5">
                            <DimCard label="Ancho" value={widthCm} />
                            <DimCard label="Alto" value={heightCm} />
                            <DimCard label="Grosor" value={thicknessCm} />
                        </div>
                    </div>

                    {/* Piezas */}
                    <div className="flex items-center justify-between py-2">
                        <span className="text-xs text-base-content/50">Piezas en escena</span>
                        <span className="badge badge-sm badge-neutral">{meshCount}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InfoPanel;
